<template>
    <div v-if="injectMember">
        <div class="form-wrap">
            <div class="member-display">
                <div v-if="selectedMemberName" class="selected-member">
                    <span class="member-name-text">{{ selectedMemberName }}</span>
                    <button @click="clearSelection" class="clear-button">
                        <span>×</span>
                    </button>
                </div>
                <div v-else class="placeholder-text">
                    Select a member
                </div>
            </div>
        </div>
        <div class="button-group">
            <button
                id="scan-button"
                type="button"
                class="btn btn-primary text-white"
                data-bs-toggle="modal"
                data-bs-target="#scanner-modal"
                @click="setModal"
            >
                <i class="fas fa-qrcode me-2"></i>Scan
            </button>
            <button
                id="select-member-button"
                type="button"
                class="btn btn-primary text-white"
                @click="openMembersModal"
            >
                <i class="fas fa-users me-2"></i>Select Member
            </button>
        </div>

        <!-- Modal for scanning -->
        <div class="modal" :class="{ hidden: hidden.value }" tabindex="-1" id="scanner-modal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Scanning</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="hidden.value = true"></button>
                    </div>
                    <div class="modal-body">
                        <div id="wrap-scanner"></div>
                        <div class="message" v-if="error_scan.message != ''">{{ error_scan.message }}</div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="closeModal">Stop scanning</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Members modal -->
        <div class="modal" :class="{ hidden: !showMembersModal }" tabindex="-1" id="members-modal">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Select Member</h5>
                        <button type="button" class="btn-close" @click="closeMembersModal"></button>
                    </div>
                    <div class="modal-body">
                        <div class="input-group mb-3">
                            <input 
                                type="text" 
                                class="form-control" 
                                placeholder="Search members..." 
                                v-model="searchQuery"
                                aria-label="Search members"
                            >
                            <button
                                class="btn btn-outline-secondary"
                                type="button"
                                v-if="searchQuery"
                                @click="clearSearch"
                                aria-label="Clear search"
                            >
                                ×
                            </button>
                        </div>
                        <div class="members-list" ref="membersListRef">
                            <div v-if="!loaded" class="text-center p-3">
                                Loading members...
                            </div>
                            <div 
                                v-else-if="loaded && filteredMembers.length === 0"
                                class="text-center p-3"
                            >
                                No members found
                            </div>
                            <div 
                                v-else
                                v-for="member in filteredMembers" 
                                :key="member.id" 
                                class="member-item p-2 border-bottom cursor-pointer hover:bg-gray-100"
                                @click="selectMember(member.id)"
                            >
                                <div class="d-flex justify-content-between align-items-center">
                                    <div>
                                        <div class="font-weight-bold">{{ member.full_name }}</div>
                                        <div class="text-muted small">{{ member.email }}</div>
                                    </div>
                                    <div v-if="selected === member.id" class="text-success">
                                        <span>✓</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="text-end w-100">
                            <button type="button" class="btn btn-secondary" @click="closeMembersModal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div v-else>
        <div class="form-wrap">
            <div class="member-display">
                <div v-if="selectedMemberName" class="selected-member">
                    <span class="member-name-text">{{ selectedMemberName }}</span>
                    <button @click="clearSelection" class="clear-button">
                        <span>×</span>
                    </button>
                </div>
                <div v-else class="placeholder-text">
                    Select a member
                </div>
            </div>
            <div class="button-group">
                <button
                    id="scan-button"
                    type="button"
                    class="btn btn-primary text-white"
                    data-bs-toggle="modal"
                    data-bs-target="#scanner-modal"
                    @click="setModal"
                >
                    <i class="fas fa-qrcode me-2"></i>Scan
                </button>
                <button
                    id="select-member-button"
                    type="button"
                    class="btn btn-primary text-white"
                    @click="openMembersModal"
                >
                    <i class="fas fa-users me-2"></i>Select Member
                </button>
            </div>
        </div>

        <!-- Modal for scanning -->
        <div class="modal" :class="{ hidden: hidden.value }" tabindex="-1" id="scanner-modal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Scanning</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="hidden.value = true"></button>
                    </div>
                    <div class="modal-body">
                        <div id="wrap-scanner"></div>
                        <div class="message" v-if="error_scan.message != ''">{{ error_scan.message }}</div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="closeModal">Stop scanning</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Members modal -->
        <div class="modal" :class="{ hidden: !showMembersModal }" tabindex="-1" id="members-modal">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Select Member</h5>
                        <button type="button" class="btn-close" @click="closeMembersModal"></button>
                    </div>
                    <div class="modal-body">
                        <div class="input-group mb-3">
                            <input 
                                type="text" 
                                class="form-control" 
                                placeholder="Search members..." 
                                v-model="searchQuery"
                                aria-label="Search members"
                            >
                            <button
                                class="btn btn-outline-secondary"
                                type="button"
                                v-if="searchQuery"
                                @click="clearSearch"
                                aria-label="Clear search"
                            >
                                ×
                            </button>
                        </div>
                        <div class="members-list" ref="membersListRef">
                            <div v-if="!loaded" class="text-center p-3">
                                Loading members...
                            </div>
                            <div 
                                v-else-if="loaded && filteredMembers.length === 0"
                                class="text-center p-3"
                            >
                                No members found
                            </div>
                            <div 
                                v-else
                                v-for="member in filteredMembers" 
                                :key="member.id" 
                                class="member-item p-2 border-bottom cursor-pointer hover:bg-gray-100"
                                @click="selectMember(member.id)"
                            >
                                <div class="d-flex justify-content-between align-items-center">
                                    <div>
                                        <div class="font-weight-bold">{{ member.full_name }}</div>
                                        <div class="text-muted small">{{ member.email }}</div>
                                    </div>
                                    <div v-if="selected === member.id" class="text-success">
                                        <span>✓</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="text-end w-100">
                            <button type="button" class="btn btn-secondary" @click="closeMembersModal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { computed, onMounted, onBeforeUnmount, reactive, ref, watch, nextTick } from '@vue/runtime-core';
import { useStore } from 'vuex';
import {Html5Qrcode} from "html5-qrcode";
import { getCurrentInstance } from 'vue';

export default {
    components: {
        // vSelect,
    },
    props: {
        modelValue: String,
        memberName: {
            type: String,
            default: ''
        },
        injectMember: { 
            type: Boolean,
            default: false
        }
    },
    emits: ["update:modelValue"],
    setup(props, ctx) {
        const store = useStore();
        const showMembersModal = ref(false);
        const searchQuery = ref('');

    const members = ref([]);
    const loaded = ref(false);
    const membersListRef = ref(null);
    const loadingMore = ref(false);
    const loadingAll = ref(false);
    const AUTO_LOAD_ALL_THRESHOLD = 500; // if total members <= this, load all automatically when scanning
        watch(() => store.state.Member.members, (newMembers) => {
            if (newMembers !== undefined) {
                members.value = (newMembers || []).map(member => ({
                    ...member,
                    full_name: `${member.title} ${member.first_name} ${member.last_name}`,
                    email: member.user?.email || '',
                    displayText: `${member.title} ${member.first_name} ${member.last_name} (${member.user?.email || ''})`
                }));
                loaded.value = true;
            }
        }, {immediate: true, deep: true});

        const selectedMemberName = computed(() => {
            if (!selected.value) return '';
            const selectedMember = members.value.find(member => member.id === selected.value);
            let name = selectedMember ? selectedMember.displayText : (props.memberName || '');
            if (name && name.length > 50) {
                return name.substring(0, 50) + '..';
            }
            return name;
        });

        const clearSelection = () => {
            selected.value = null;
        };

        const filteredMembers = computed(() => {
            const query = searchQuery.value.toLowerCase();
            if (!query) return members.value;
            
            return members.value.filter(member => 
                member.full_name.toLowerCase().includes(query) ||
                member.email.toLowerCase().includes(query)
            );
        });

        const selected = computed({
            get() {
                return props.modelValue;
            },
            set(val) {
                ctx.emit('update:modelValue', val);
            }
        });

        const error_scan = reactive({
            message: '',
        });

        let scanner = "";
        let camera_id = "";

        const preloadAbort = ref(false);
        const loadingPreload = ref(false);
        const allLoaded = ref(false);

        const selectedBusinessProfile = reactive({
            corporate_id: '',
        });

        const hidden = reactive({
            value: true
        });

        const { emit } = getCurrentInstance();

        const openMembersModal = async () => {
            searchQuery.value = '';
            showMembersModal.value = true;
            await nextTick();
            attachScrollListener();
            await loadBusinessProfie();
            allLoaded.value = false;
            await loadMembers();
            emit('membersLoaded');
        };

        const closeMembersModal = () => {
            showMembersModal.value = false;
            detachScrollListener();
        };

        const loadAllMembers = async () => {
            if (loadingAll.value) return;
            loadingAll.value = true;
            try {
                await store.dispatch('Member/all', selectedBusinessProfile.corporate_id);
                allLoaded.value = true;
                loaded.value = true;
                await nextTick();
                attachScrollListener();
            } catch (e) {
                console.error('loadAllMembers failed', e);
            } finally {
                loadingAll.value = false;
            }
        };

        const selectMember = (memberId) => {
            selected.value = memberId;
            closeMembersModal();
        };

        onMounted(async() => {
            Html5Qrcode.getCameras().then((devices) => {
                if (devices && devices.length) {
                    camera_id = devices[0].id;
                }
            }).catch((err) => console.log(err));
        });

        const attachScrollListener = () => {
            if (membersListRef.value) {
                membersListRef.value.addEventListener('scroll', handleScroll);
            }
        };

        const detachScrollListener = () => {
            if (membersListRef.value) {
                membersListRef.value.removeEventListener('scroll', handleScroll);
            }
        };

        onBeforeUnmount(() => {
            detachScrollListener();
            try {
                if (scanner && scanner.clear) scanner.clear();
            } catch (e) {
                console.error('Failed to clear scanner on unmount', e);
            }
        });

        const onScanSuccess = async (decodedText) => {
            let member;
            try {
                member = JSON.parse(decodedText);
            } catch (e) {
                error_scan.message = 'Invalid QR data';
                setTimeout(() => { error_scan.message = ''; }, 1000);
                return;
            }

            let selected_member = store.state.Member.members.find((v) => v.id == member.memberId);

            if (selected_member) {
                ctx.emit('update:modelValue', member.memberId);
                closeModal();
                return;
            }

            // Fallback: fetch single member by id from API, append to store, then select
            try {
                const res = await store.dispatch('Member/read_single', member.memberId);
                if (res) {
                    store.commit('Member/add_single_member', { member: res });
                    ctx.emit('update:modelValue', member.memberId);
                    closeModal();
                    return;
                }
                error_scan.message = 'Member not found';
                setTimeout(() => { error_scan.message = ''; }, 1000);
            } catch (err) {
                console.error('read_single failed', err);
                error_scan.message = 'Member not found';
                setTimeout(() => { error_scan.message = ''; }, 1000);
            }
        }

        const startCamera = () => {
            scanner = new Html5Qrcode("wrap-scanner");
            const config = {fps: 4, qrbox: {width: "100%", height: "100%"}};
            scanner.start({deviceId: {exact: camera_id}}, config, onScanSuccess)
                .then(async () => {
                    preloadAbort.value = false;
                    const memberMeta = store.state.Member.meta || {};
                    const total = parseInt(memberMeta.total) || 0;
                    if (total > 0 && total <= AUTO_LOAD_ALL_THRESHOLD) {
                        await loadAllMembers();
                    } else {
                        preloadMembers().catch((e) => {
                            console.error('preloadMembers failed', e);
                        });
                    }
                })
                .catch((err) => {
                    console.error('scanner.start failed', err);
                });
        }

        const setModal = () => {
            hidden.value = !hidden.value;
            startCamera();
        }

        const closeModal = () => {
            try {
                if (scanner && scanner.stop) scanner.stop();
            } catch (e) {
                console.error('Failed to stop scanner', e);
            }
            preloadAbort.value = true;
            hidden.value = true;
        }

        const sleep = (ms) => new Promise(res => setTimeout(res, ms));

        const preloadMembers = async () => {
            if (loadingPreload.value) return;
            loadingPreload.value = true;
            try {
                let continueLoading = true;
                while (!preloadAbort.value && continueLoading) {
                    const memberMeta = store.state.Member.meta || {};
                    const currentPage = memberMeta.page || 1;
                    const limit = memberMeta.limit || 10;

                    const nextMeta = { ...memberMeta, page: currentPage + 1 };
                    store.commit('Member/switch_page', { meta: nextMeta });

                    let result;
                    try {
                        result = await store.dispatch('Member/read');
                    } catch (e) {
                        console.error('Error preloading members page', nextMeta.page, e);
                        break;
                    }

                    const fetched = (result?.data?.data || []).length;
                    const returnedMeta = result?.data?.meta || {};

                    const totalPages = returnedMeta.total_pages || null;
                    if (totalPages !== null) {
                        if ((returnedMeta.page || 0) >= totalPages) {
                            continueLoading = false;
                            break;
                        }
                    }

                    if (fetched === 0) {
                        continueLoading = false;
                        break;
                    }

                    if (fetched < limit) {
                        continueLoading = false;
                        break;
                    }

                    await sleep(200);
                }
            } finally {
                loadingPreload.value = false;
            }
        }

        const handleScroll = async () => {
            const el = membersListRef.value;
            if (!el || loadingMore.value) return;

            const distanceToBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
            if (distanceToBottom < 150) {
                const memberMeta = store.state.Member.meta || {};
                const currentPage = memberMeta.page || 1;
                const limit = memberMeta.limit || 10;
                const total = memberMeta.total || 1;
                const totalPages = memberMeta.total_pages || (total > limit ? Math.ceil(total / limit) : total);
                if (currentPage < totalPages) {
                    loadingMore.value = true;
                    const nextMeta = { ...memberMeta, page: currentPage + 1 };
                    store.commit('Member/switch_page', { meta: nextMeta });
                    try {
                        await store.dispatch('Member/read');
                    } catch (e) {
                        console.error('Failed to load more members', e);
                    } finally {
                        loadingMore.value = false;
                    }
                } else {
                    if (!allLoaded.value) {
                        try {
                            await loadAllMembers();
                        } catch (e) {
                            console.error('Failed to load all members on scroll end', e);
                        }
                    }
                }
            }
        };

        // debounce search so typing triggers server-side search
        let searchDebounce = null;
        watch(searchQuery, (val) => {
            if (searchDebounce) clearTimeout(searchDebounce);
            searchDebounce = setTimeout(async () => {
                const query = (val || '').trim();
                
                if (query === '') {
                    store.commit('Member/clear_search');
                    await loadMembers();
                    return;
                }

                try {
                    members.value = [];
                    loaded.value = false;

                    await store.dispatch('Member/all', selectedBusinessProfile.corporate_id);
                
                    members.value = store.state.Member.members.filter(member => {
                        const fullName = `${member.title} ${member.first_name} ${member.last_name}`.toLowerCase();
                        const email = (member.user?.email || '').toLowerCase();
                        const searchLower = query.toLowerCase();
                        return fullName.includes(searchLower) || email.includes(searchLower);
                    }).map(member => ({
                        ...member,
                        full_name: `${member.title} ${member.first_name} ${member.last_name}`,
                        email: member.user?.email || '',
                        displayText: `${member.title} ${member.first_name} ${member.last_name} (${member.user?.email || ''})`
                    }));
                    
                    loaded.value = true;
                } catch (e) {
                    console.error('member search failed', e);
                    await loadMembers();
                }
            }, 350);
        });

        const loadBusinessProfie = async () => {
            await store.dispatch('Auth/getBusinessProfile').then((businessProfile) => {
                selectedBusinessProfile.corporate_id = businessProfile.corporate_id;
            });
        }

        const loadMembers = async () => {
            loaded.value = false;
            members.value = [];
            store.commit('Member/reset_meta');
            store.commit('Member/add_filter', { filter: { corporate_id: selectedBusinessProfile.corporate_id } });
            try {
                await store.dispatch('Member/read');
            } catch (e) {
                console.error('Failed to load members', e);
            }
        }

        const clearSearch = async () => {
            searchQuery.value = '';
            store.commit('Member/clear_search');
            try {
                await loadMembers();
            } catch (e) {
                console.error('Failed to reload members after clearing search', e);
            }
        }

        return {
            members,
            hidden,
            setModal,
            closeModal,
            selected,
            error_scan,
            showMembersModal,
            openMembersModal,
            closeMembersModal,
            selectMember,
            searchQuery,
            filteredMembers,
            selectedMemberName,
            clearSelection,
            clearSearch,
            loaded,
            membersListRef,
            loadAllMembers,
            loadingAll,
        }
    }
}
</script>

<style scoped>
    .form-wrap {
        display: flex;
        width: 100%;
        align-items: center;
        padding: 0.5rem;
    }

    .member-display {
        flex: 1;
        min-width: 300px;
        max-width: 600px;
        height: 40px;
        border: 1px solid #ced4da;
        border-radius: 0.375rem;
        background-color: #fff;
        padding: 0 0.75rem;
        display: flex;
        align-items: center;
        position: relative;
    }

    .selected-member {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding-right: 24px;
    }

    .member-name-text {
        font-size: 0.9rem;
        color: #333;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .placeholder-text {
        color: #6c757d;
        font-size: 0.9rem;
    }

    .clear-button {
        position: absolute;
        right: 8px;
        top: 50%;
        transform: translateY(-50%);
        border: none;
        background: transparent;
        padding: 0;
        margin: 0;
        cursor: pointer;
        font-size: 1.25rem;
        line-height: 1;
        color: #999;
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .clear-button:hover {
        color: #666;
    }

    .button-group {
        display: flex;
        gap: 0.5rem;
        flex-shrink: 0;
    }

    .btn {
        padding: 0.5rem 1rem;
        font-size: 0.9rem;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        height: 40px;
        white-space: nowrap;
    }

    .btn-primary {
        background-color: var(--primary-color, #FC6666) !important;
        border-color: var(--primary-color, #FC6666) !important;
        color: #fff !important;
    }

    .btn-primary:hover {
        filter: brightness(0.9);
    }

    .btn-secondary {
        background-color: var(--secondary-color, #FEE9E9) !important;
        color: var(--primary-color, #FC6666) !important;
        border: 1px solid var(--secondary-color, #FEE9E9) !important;
    }

    .btn-secondary:hover {
        filter: brightness(0.9);
    }

    @media (max-width: 768px) {
        .form-wrap {
            flex-direction: column;
            align-items: stretch;
            padding: 0px;
        }

        .vue-select {
            max-width: 100%;
            width: 100%;
        }

        .button-group {
            width: 105%;
            min-width: 0px;
            margin-left: 0px;
            margin-top: 1rem;
            justify-content: space-between;
        }
        .button-group button {
            width: 105%;
            min-width: 0px;
        }

        .member-display {
            width: 105%;
            min-width: 0px;
        }

        #scan-button {
            width: 52%;
            min-width: 0px;
        }
    }

    .members-list {
        max-height: 60vh;
        overflow-y: auto;
        border: 1px solid #eee;
        border-radius: 0.375rem;
    }

    .member-item {
        padding: 1rem;
        border-bottom: 1px solid #eee;
        cursor: pointer;
        transition: background-color 0.2s;
    }

    .member-item:hover {
        background-color: #f8f9fa;
    }

    .member-name {
        font-weight: 600;
        color: #333;
    }

    .member-email {
        font-size: 0.85rem;
        color: #666;
    }

    .selected-check {
        color: #28a745;
        font-size: 1.2rem;
    }

    .input-group .input-group-text {
        background-color: #fff;
        border-right: none;
    }

    .input-group {
        display: flex;
        align-items: center;
    }

    .input-group input[aria-label="Search members"] {
        border: 1px solid #ced4da;
        background-color: #ffffff;
        border-radius: 6px 0 0 6px;
        padding: 0.5rem 0.75rem;
        transition: border-color 150ms ease, box-shadow 150ms ease, color 150ms ease;
        outline: none;
        box-shadow: none;
        height: 38px;
    }

    .input-group .btn[aria-label="Clear search"] {
        border: 1px solid #ced4da;
        border-left: none;
        background: transparent;
        color: #6c757d;
        padding: 0 0.6rem;
        border-radius: 0 6px 6px 0;
        transition: color 150ms ease, border-color 150ms ease, background-color 150ms ease;
        height: 38px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }

    .input-group input[aria-label="Search members"]:hover,
    .input-group input[aria-label="Search members"]:focus {
        border-color: #ced4da;
        color: #212529;
    }

    .input-group .btn[aria-label="Clear search"]:hover {
        color: #dc3545;
        border-color: #dc3545;
        background-color: rgba(220,53,69,0.03);
    }
</style>